import React from 'react'
import { Modal, Form, Input, Alert } from 'antd'
import { useTranslation } from 'react-i18next'
import { CheckCircleOutlined } from '@ant-design/icons'

interface ReleaseHoldModalProps {
  visible: boolean
  onCancel: () => void
  onConfirm: (resolutionNote: string) => void
  count: number
  confirmLoading?: boolean
}

const ReleaseHoldModal: React.FC<ReleaseHoldModalProps> = ({
  visible,
  onCancel,
  onConfirm,
  count,
  confirmLoading = false
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm<{ resolution_note?: string }>()

  const handleOk = () => {
    form.validateFields().then(values => {
      // Form 欄位無 required，runtime 可能 undefined；callers 簽名宣告 string，原 .jsx 即如此通過
      onConfirm(values.resolution_note as string)
    })
  }

  React.useEffect(() => {
    if (!visible) {
      form.resetFields()
    }
  }, [visible, form])

  return (
    <Modal
      title={
        <span>
          <CheckCircleOutlined style={{ color: '#52c41a', marginRight: '8px' }} />
          {count > 1
            ? (t('shared.order_holds.list.batch_release_title') || t('shared.orders.detail.actions.release_holds'))
            : t('shared.orders.detail.actions.release_holds')
          }
        </span>
      }
      open={visible}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={confirmLoading}
      okText={t('common.button.confirm')}
      cancelText={t('common.button.cancel')}
    >
      <Alert
        message={count > 1
          ? t('shared.order_holds.list.batch_release_confirm', { count })
          : t('shared.orders.detail.actions.release_holds_confirm_content', { orderName: '' }).replace('{{orderName}}', '').trim()
        }
        type="info"
        showIcon
        style={{ marginBottom: '16px' }}
      />

      <Form form={form} layout="vertical">
        <Form.Item
          name="resolution_note"
          label={t('shared.orders.detail.actions.hold_note_label')}
        >
          <Input.TextArea
            rows={4}
            placeholder={t('shared.order_holds.list.resolution_note_placeholder') || t('shared.orders.detail.actions.hold_note_placeholder')}
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default ReleaseHoldModal
